export const SITE_NAME = "Flake.art";
